import { lazy } from 'react';
import { FlagOutlined } from '@ant-design/icons';
import lazyComponent from './lazy';
import { BANNERS_ALLOWED_ROLES } from '../util/stateAccess';

const Banners = lazy(() => import('../containers/Banners'));

const states = [
  {
    key: 'view_banners',
    url: 'banners',
    name: 'App.Banners',
    title: 'Banners',
    views: {
      'main@App': lazyComponent(Banners),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <FlagOutlined />,
      },
      roles: BANNERS_ALLOWED_ROLES,
    },
  },
];

export default states;
